<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{ innerText?: string; index?: number }>(),
  {
    innerText: '大标题'
  }
);

const translateY = ref(props.innerText.length * 26 + 65);
const x2 = ref(963 - props.innerText.length * 26);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="40" viewBox="0 0 1023.539 30">
  <g id="xiaobiao1" transform="translate(-1 -9)">
    <path id="路径_4611" data-name="路径 4611" d="M0,0H20.165V20.166H0Z" transform="translate(25.063 10.48) rotate(45)" fill="var(--theme-color-1)" fill-opacity="0.6"/>
    <text id="项目执行人性别分布" transform="translate(46.039 32)" fill="#222" font-size="22" font-weight="600" letter-spacing="0.09em"><tspan x="0" y="0">${props.innerText}</tspan></text>
    <path id="路径_854" data-name="路径 854" d="M0,0H20.165V20.166H0Z" transform="translate(15.26 10.48) rotate(45)" fill="var(--theme-color-1)"/>
    <line id="直线_696" data-name="直线 696" x2="${x2.value}" transform="translate(${translateY.value} 25)" fill="none" stroke="var(--theme-color-1)" stroke-width="1"/>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped></style>
